import $ from 'jquery';

class AnimateNumbers {
    constructor() {
        this.$document = $(document);
        this.$window = $(window);

        const numbers = document.querySelectorAll('.js-number');

        if (numbers) {
            const observer = new IntersectionObserver(AnimateNumbers.movingNumbers);
            numbers.forEach((number) => observer.observe(number));
        }
    }

    static movingNumbers(entries) {
        entries.forEach((entry) => {
            const numberToAnimate = entry.target.getAttribute('data-number');

            $(entry.target).prop('Counter', 0).animate({
                Counter: numberToAnimate,
            }, {
                duration: 2000,
                easing: 'swing',
                step(now) {
                    $(this).text(Math.ceil(now));
                },
            });
        });
    }
}

export default AnimateNumbers;
